import { PropsWithChildren, ReactNode, FC } from 'react';
import { Typography } from '@ui/components';
import { cn } from '@ui/utils';

interface PaymentCardProps {
  icon?: ReactNode;
  className?: string;
  disabled?: boolean;
  subtitle: string;
  title: string;
  onClick?: () => void;
}

export const PaymentCard: FC<PropsWithChildren<PaymentCardProps>> = ({
  disabled = false,
  className,
  subtitle,
  children,
  title,
  icon,
  onClick,
}) => {
  return (
    <div
      className={cn(
        'flex items-center gap-3 px-3 py-4 justify-between w-full border border-border-default rounded-md box-border group',
        disabled && 'disabled',
        className,
      )}
      onClick={onClick}
    >
      <div className="grid grid-cols-[auto_1fr_1fr] gap-x-3 gap-y-0.5 group-[.disabled]:opacity-50">
        {icon && (
          <div className="h-8 w-12 row-span-2 border border-border-default flex items-center justify-center p-2">
            {icon}
          </div>
        )}
        <Typography className="col-span-2" variant="h100">
          {title}
        </Typography>
        <Typography className="col-span-2 text-weak" variant="labelSmallBook">
          {subtitle}
        </Typography>
      </div>

      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
};
